import React, { Component } from 'react';
import { connect } from 'react-redux';
import {TextField, Paper,MenuItem} from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import {searchKundBasic} from 'actions'
import { isEmpty } from 'lodash';
import IntlMessages from 'util/IntlMessages';
function mapStateToProps({accountsData, auth}) {
  const { searchedKundBasic } = accountsData;
  const { authUser } = auth;
  return {
    searchedKundBasic,authUser
  };
}

function mapDispatchToProps(dispatch) {
  return {
    searchKundBasic: (searchText, Afid, userid) => dispatch(searchKundBasic(searchText, Afid, userid)),
    dispatch
  };
}

class AutoComplete extends Component {
  state={
    searchedKund:[],
    selectedKund:{}
  }
  componentDidMount=()=>{
    this.setState({
      searchedKund: this.props.searchedKundBasic
    })
  }
  componentDidUpdate=()=>{
    if(this.props.searchedKundBasic !== this.state.searchedKund){
      this.setState({
        searchedKund: this.props.searchedKundBasic
      })
    }
  }
  getMatchedKund=(e)=>{
    console.log(e.target.value)
    if(e.target.value.length >= 4){
      this.props.onStartLoading()
      const userid = this.props.authUser.user_id;
      const Afid = this.props.authUser.user_Afid;
      this.props.searchKundBasic(e.target.value,Afid, userid)
    }    
  }
  selectedThisKund=(Value)=>{
    
    if(!isEmpty(Value)){
      this.setState({
        selectedKund:Value
      })
      this.props.selectthisKund(Value)
      setTimeout(()=> {
        this.props.onEndLoading()
      }, 1000);
      
    }
  }
  render() {
    console.log(this.props.searchKundBasic)
    return (
      <div>
        {this.props.isFrom === 1 ?
        <TextField 
        fullWidth
          label={<IntlMessages id="appKontoModule.foretagsnamn"/>}
          variant="outlined"
          size="small"
          value={this.props.KundNamn}
          InputLabelProps={{shrink: true,}}
        />
        :
         <Autocomplete
         id="combo-box-demo"
         options={(isEmpty(this.state.searchedKund)?[]:this.state.searchedKund)}
         getOptionLabel={(option) => option.KundNamn}
         fullWidth
         error={isEmpty(this.props.selectedKund.Orgnr)}
         value={this.state.selectedKund.KundNamn}
         onChange={(e,Value)=>this.selectedThisKund(Value)}
         renderInput={(params) => 
          <TextField 
          {...params} 
          fullWidth
          label={<IntlMessages id="appKontoModule.foretagsnamn"/>}
          variant="outlined"
          error={isEmpty(this.props.Kund.Orgnr)}
          size="small"
          value={this.state.selectedKund.KundNamn}
          onChange={this.getMatchedKund}
          InputLabelProps={{
            shrink: true,
          }}
          />}
        />
        }
        
      </div>
    );
  }
}

export default connect(
  mapStateToProps,mapDispatchToProps
)(AutoComplete);


